import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

function PageNotFound() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh'
      }}
    >
      <h1>404 Page Not Found</h1>
      <Link to="/">
        <Button size="large">Go to Dashboard</Button>
      </Link>
    </div>
  );
}

export default PageNotFound;
